export const calculateLvr = (options) => {
  const loanAmount = options?.loanAmount;
  const propertyValue = options?.propertyValue;

  return Number(((loanAmount / propertyValue) * 100)?.toFixed(2));
};
